import { useContext, useEffect, useState } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import getIRGQuery from '../queries/irg/getIRGQuery';
import { getProductQuery } from '../queries';
import DataProviderContext from '../react/DataProviderContext';
import { useQuery } from './useQuery';

const useIRG = ({
  itemId,
  maxItems,
  storeId,
  domains = [],
  ssr = true
}) => {

  const opts = {
    ssr,
    errorPolicy: 'all',
    variables: {
      itemId,
      maxItems
    }
  };

  const dpContext = useContext(DataProviderContext);
  const ctx = useContext(ExperienceContext);

  const Query = getIRGQuery({ domains });

  if (storeId) {
    opts.variables.storeId = storeId;
  }
  const resp = useQuery(Query, opts);

  if (dpContext.productCache && resp.data) {
    const products = [
      ...(resp.data?.dynamicRecs?.irg?.collection?.products || []),
      ...(resp.data?.dynamicRecs?.irg?.accessories?.products || []),
      ...(resp.data?.dynamicRecs?.irg?.coordinatingItems?.products || []),
    ];
    products.forEach(({ product }) => {
      dpContext.productCache.addProduct({
        product,
        storeId: resp.variables.storeId || '8119'
      });
    });
  }

  return resp;
};

export default useIRG;
